'use client'

import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select'
import React, { useState } from 'react'

import { type Locale } from '../types'
import { useLocale } from '../index'
import { getHostnameWithLocale, localeMap } from '@/utilities/getLocale'
import { i18n } from './i18n'

export function getEditionTitle(locale: Locale) {
    return i18n[locale].edition
}

export const LocaleSelector: React.FC = () => {
    const { locale } = useLocale()
    const [open, setOpen] = useState(false)

    const onLocaleChange = (localeToSet: Locale) => {
        // get path and redirect
        const hostname = getHostnameWithLocale(window.location.host, localeToSet)

        // Transferring across domains, we will want to hard migrate
        // Drop utm query parameters to keep metrics clean
        window.location.href = `${window.location.protocol}//${hostname}${window.location.pathname}`
    }

    return (
        <Select onValueChange={onLocaleChange} value={locale} open={open} onOpenChange={setOpen}>
            <SelectTrigger className='w-auto bg-transparent gap-2 pl-0 md:pl-3 border-none focus:ring-0 focus:ring-offset-0' onMouseOver={() => setOpen(true)}>
                <SelectValue>{getEditionTitle(locale)}</SelectValue>
            </SelectTrigger>
            <SelectContent>
                {Object.entries(localeMap)
                    .filter(([code]) => code !== locale)
                    .sort(([codeA], [codeB]) => codeA.localeCompare(codeB))
                    .map(([code, display]) => (
                        <SelectItem key={code} value={code}>
                            {display}
                        </SelectItem>
                    ))}
            </SelectContent>
        </Select>
    )
}
